































































































































import Vue, { PropOptions } from 'vue'

import { CurrentUser } from '@raksul/raksul-common-ui'

export default Vue.extend({
  props: {
    currentUser: {
      required: true,
      validator: v => typeof v === 'object' || v === null
    } as PropOptions<CurrentUser>,
    coreUrl: {
      type: String,
      required: true
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
})
